module.exports = __webpack_public_path__ + "static/media/background-mask-mirror.808abe4c.svg";